export default __webpack_public_path__ + "static/media/gallery_02.8a7bfa50.jpg";